import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExcelImportService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI1 + "/api";
  url1 = environment.serverAPI4 + "/api";
  url12 = environment.serverAPI6 + "/api";
  url13 = environment.serverAPI9 + "/api";
  url14 = environment.serverAPI5 + "/api";

  excelImportNewsLetter(data: FormData): Observable<Object> {
    return this.http.post(`${this.url}/newslettersubscriber/upload`, data);
  }

  excelImportShippingTable(data: FormData): Observable<Object> {
    return this.http.post(`${this.url1}/shippingtablerate/upload`, data);
  }

  excelImportCurrencyRate(data: FormData): Observable<Object> {
    return this.http.post(`${this.url1}/currency/upload`, data);
  }

  excelImportSearchQuery(data: FormData): Observable<Object> {
    return this.http.post(`${this.url1}/searchquery/upload`, data);
  }

  excelImportBuilder(data: FormData): Observable<Object> {
    return this.http.post(`${this.url1}/builder/upload`, data);
  }

  excelImportHousingbuilder(data: FormData): Observable<Object> {
    return this.http.post(`${this.url1}/housingbuilder/upload`, data);
  }

  excelImportHousingLocation(data: FormData): Observable<Object> {
    return this.http.post(`${this.url1}/housinglocation/upload`, data);
  }

  excelImportPincode(data: FormData): Observable<Object> {
    return this.http.post(`${this.url1}/config/pincode/upload`, data);
  }

  excelImportProductQtyAndPrice(data: FormData): Observable<Object> {
    return this.http.post(`${this.url1}/product/update/upload`, data);
  }
  excelImportSupplier(data: FormData): Observable<Object> {
    return this.http.post(`${this.url1}/supplier/upload`, data);
  }
  excelImporthrmLocations(data: FormData): Observable<Object> {
    return this.http.post(`${this.url12}/hrmLocation/upload`, data);
  }
  excelImportProductNameAndDescription(data: FormData): Observable<Object> {
    return this.http.post(`${this.url1}/product/name/upload`, data);
  }

  excelImportCategories(data: FormData): Observable<Object> {
    return this.http.post(`${this.url13}/posCategories/upload`, data);
  }

  excelImportProducts(data: FormData): Observable<Object> {
    return this.http.post(`${this.url13}/posproducts/upload`, data);
  }

  excelImportPurchaseOrder(data: FormData): Observable<Object> {
    return this.http.post(`${this.url14}/purchasesOrder/upload`, data);
  }

  excelImportSales(data: FormData): Observable<Object> {
    return this.http.post(`${this.url14}/sales/upload`, data);
  }

  excelImportSalesReturn(data: FormData): Observable<Object> {
    return this.http.post(`${this.url14}/salesreturn/upload`, data);
  }


}
